export default {
    Metadata: {
        Name: "Ceiling",
        Description: "Returns the smallest integer greater than or equal to a given number.",
        Syntax: "Ceiling(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(ofValue) {
        return Math.ceil(ofValue);
    },
};

